module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/assets/languages/vi.json
// module id = VXzr
// module chunks = 1